import { State } from 'reducers/State';
import { createSelector } from 'reselect';

export const locationPathnameSelector = (state: State): string =>
  state.router.location.pathname;

const rawLocationQuerySelector = (state: State): Record<string, string> =>
  state.router.location.query;

export const locationQuerySelector: (state: State) => Record<string, string> =
  createSelector(rawLocationQuerySelector, (query) => {
    // unescape the query strings
    const out: Record<string, string> = {};
    return Object.keys(query).reduce((acc, key) => {
      acc[key] = decodeURIComponent(query[key]);
      return acc;
    }, out);
  });

export const pageNumberSelector = (state: State) => {
  const page = locationQuerySelector(state)['page'];
  if (page) {
    return parseInt(page, 10);
  }
  return 1;
};

export const selectors = {
  locationPathnameSelector,
  locationQuerySelector,
  pageNumberSelector,
};
